import React, { useContext, useEffect } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import 'date-fns'
import moment from 'moment'

import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'

import Context from '../../context'

export default function WeekDaysForm() {
  const { formObject, setFormObject } = useContext(Context)

  useEffect(() => {
    // if (formObject.partnerUnityOpeningHours.length < 1) {
    //   setFormObject({ ...formObject, partnerUnityOpeningHours: ValidDays });
    // }
  }, [formObject])

  const updateIsValid = index => {
    const newArr = [...formObject.partnerUnityOpeningHours]
    newArr[index].isValid = !newArr[index].isValid

    setFormObject({ ...formObject, partnerUnityOpeningHours: newArr })
  }

  const updateOpen = index => date => {
    const newArr = [...formObject.partnerUnityOpeningHours]
    newArr[index].open = date

    setFormObject({ ...formObject, partnerUnityOpeningHours: newArr })
  }

  const updateClose = index => date => {
    const newArr = [...formObject.partnerUnityOpeningHours]

    newArr[index].close = date < newArr[index].open ? moment(date).add(1, 'd').toDate() : date

    setFormObject({ ...formObject, partnerUnityOpeningHours: newArr })
  }

  useEffect(() => {
    console.log('formmmmm', formObject.partnerUnityOpeningHours)
  }, [])

  return (
    <>
      <h6 className="form-titles">Dias da Semana e horários válidos para o desconto:</h6>

      {formObject.partnerUnityOpeningHours.map((day, index) => (
        <div key={day.id} className="form-row">
          <div className="col d-flex align-items-center">
            <div className="form-check form-group align-items-center ">
              <input
                className="form-check-input"
                type="checkbox"
                id={`weekDay${day.id}`}
                checked={formObject.partnerUnityOpeningHours[index].isValid}
                onChange={() => updateIsValid(index)}
              />
              <label htmlFor={`weekDay${day.id}`} className="form-check-label">
                {day.day}
              </label>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardTimePicker
                  ampm={false}
                  disabled={!formObject.partnerUnityOpeningHours[index].isValid}
                  margin="normal"
                  id={`start-day-${day.id}`}
                  label="Válido a partir das..."
                  value={formObject.partnerUnityOpeningHours[index].open}
                  onChange={updateOpen(index)}
                  KeyboardButtonProps={{
                    'aria-label': 'Selecione a Hora'
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardTimePicker
                  ampm={false}
                  disabled={!formObject.partnerUnityOpeningHours[index].isValid}
                  margin="normal"
                  id={`end-day-${day.id}`}
                  label="Válido até..."
                  value={formObject.partnerUnityOpeningHours[index].close}
                  onChange={updateClose(index)}
                  KeyboardButtonProps={{
                    'aria-label': 'change time'
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
        </div>
      ))}
    </>
  )
}
